import { el } from '../../core/dom.js';
import { gcpAutofill } from './schemas.js';

function control(field, value, hint) {
  const attrs = {
    'data-cred': field.key,
    placeholder: hint || field.placeholder || '',
    autocomplete: 'off',
  };
  if (field.type === 'textarea') {
    const node = el('textarea', { ...attrs, rows: '4' });
    if (value) node.value = value;
    return node;
  }
  if (field.type === 'select') {
    const select = el('select', { 'data-cred': field.key },
      el('option', { value: '' }, 'Select…'),
      (field.options || []).map((option) => el('option', {
        value: option.value,
        selected: value === option.value ? true : null,
      }, option.label || option.value)));
    if (value) select.value = value;
    return select;
  }
  const input = el('input', {
    ...attrs,
    type: field.type === 'password' ? 'password' : 'text',
    value: value || '',
  });
  return input;
}

function fieldNode(field, value, hint) {
  // Labels that already say "(optional)" keep a single marker; optional flag still skips required.
  const alreadyOptional = /\(optional\)\s*$/i.test(field.label || '');
  const label = field.optional && !alreadyOptional ? `${field.label} (optional)` : field.label;
  return el('label', { class: 'cx-field' },
    el('span', { class: 'cx-field-label' }, label),
    control(field, value, hint),
    field.help ? el('span', { class: 'cx-field-help' }, field.help) : null);
}

function applyAutofill(slug, root, status, raw) {
  const result = gcpAutofill(raw, slug);
  status.textContent = result.message || '';
  for (const [key, value] of Object.entries(result.values || {})) {
    const node = root.querySelector(`[data-cred="${key}"]`);
    if (!node) continue;
    node.value = value;
    // Notify the dialog handshake (programmatic fills don't fire input by default).
    node.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

function autofillBox(slug, root) {
  const status = el('span', { class: 'cx-hint' });
  const area = el('textarea', {
    rows: '4',
    placeholder: '{ "type": "service_account", "project_id": "...", ... }',
    autocomplete: 'off',
    onInput: () => applyAutofill(slug, root, status, area.value),
  });
  return el('label', { class: 'cx-field' },
    el('span', {}, 'Paste full JSON key file (optional — fills the fields below)'),
    area,
    status);
}

export function renderFields(schema, slug, preset) {
  const values = (preset && preset.values) || {};
  const hints = (preset && preset.hints) || {};
  const root = el('div', { class: 'cx-fields' });
  if (schema && schema.intro) root.append(el('p', { class: 'cx-hint' }, schema.intro));
  if (schema && schema.notice) root.append(el('p', { class: 'cx-hint' }, schema.notice));
  if (schema && schema.autofill) root.append(autofillBox(slug, root));
  const fields = schema
    ? schema.fields
    : [{ key: 'value', label: 'Credential', type: 'password', placeholder: 'Paste your API key' }];
  for (const field of fields) root.append(fieldNode(field, values[field.key] || '', hints[field.key] || ''));
  return root;
}

export function readFields(root) {
  const values = {};
  root.querySelectorAll('[data-cred]').forEach((node) => {
    values[node.getAttribute('data-cred')] = node.value.trim();
  });
  return values;
}

export function textField(key, label, value, hint) {
  return fieldNode({ key, label, type: 'text', placeholder: hint || '' }, value || '', '');
}
